<auth-page-layout title="Patient Portal"
                  logoUrl="" cardTitle="We're Sorry"
                  illustration="">
  <p>This patient portal is no longer active.</p>
  <p>Please contact the office with any questions.</p>
</auth-page-layout>
